// removed by extract-text-webpack-plugin
module.exports = {"moment":"moment_2AVJG","editMenu":"editMenu_3eyoE","blackwhite":"blackwhite_2u_oP","draggablePhoto":"draggablePhoto_3SVGD","photo":"photo_2qPQm","placeholder":"placeholder_SpzDB"};


//////////////////
// WEBPACK FOOTER
// ./app/components/moment-photo/styles.scss
// module id = 470
// module chunks = 1